import React, { useEffect, useRef } from "react";
import * as XLSX from "xlsx";
import { trNormalize } from "../../utils/text";

export default function DataLoader({ onLoaded }) {
  const latestOnLoaded = useRef(onLoaded);
  useEffect(() => {
    latestOnLoaded.current = onLoaded;
  }, [onLoaded]);

  const detectType = (fileName, rows) => {
    const lowerName = (fileName || "").toLowerCase();
    const cols = Object.keys(rows?.[0] || []);
    const ncols = cols.map((c) => trNormalize(c));
    const hasBuffDist = ncols.some((c) => c.includes("buff") || c === "buff_dist");
    const hasAdres = ncols.some((c) => c.includes("adres") || c.includes("unnamed") || c === "__empty");
    const hasUsers = ncols.some(
      (c) => c.includes("tekil") || c.includes("kullanici") || c === "users"
    );
    if (lowerName.includes("buff") || hasBuffDist) return "buff";
    if (lowerName.includes("mobility") || (hasAdres && hasUsers)) return "mobility";
    return "unknown";
  };

  // StrictMode guard: sadece 1 kez çalıştır
  const didRunRef = useRef(false);

  useEffect(() => {
    if (didRunRef.current) return;
    didRunRef.current = true;

    (async () => {
      try {
        const res = await fetch("/data/my2.xlsx");
        const buf = await res.arrayBuffer();
        const wb = XLSX.read(buf, { type: "array" });
        const sheet = wb.SheetNames[0];
        const rows = XLSX.utils.sheet_to_json(wb.Sheets[sheet], { defval: null });
        const type = detectType("mydata.xlsx", rows);

        latestOnLoaded.current?.([
          { name: "mydata", type, rows },
        ]);
      } catch (e) {
        console.error("Excel yüklenemedi:", e);
      }
    })();
  }, []); // <- bağımlılık yok, tek sefer

  return <span className="text-sm text-slate-600"></span>;
}
